import * as React from 'react';
import { MembershipPlanIndexView, MembershipPlanKey } from '../../../types/membershipPlans';
import './selectedPlanSummary.module.scss';

const PlanDescription = ({ plan }) => {
    switch (plan.key) {
        case MembershipPlanKey.CASUAL:
            return <span>月5回までレッスンを受けられるプランです。</span>;
        case MembershipPlanKey.REGULAR:
            return <span>レッスンの閲覧数に制限がなく、最短で様々な内容を学べます。</span>;
        default:
            return null;
    }
};

type Props = {
    plan: MembershipPlanIndexView;
};

export const SelectedPlanSummary = ({ plan }: Props) => (
    <div styleName="selected-plan-summary">
        <div styleName="description">
            <PlanDescription plan={plan} />
        </div>
    </div>
);
